// @flow
import React from "react";
import { localize } from "redux-i18n";
import config from "@config";
import type { PaginationExtendedType } from "@types";
import type { HierarchyChangelog } from "@modules/hierarchy/reducer/change-log/types";
import { formatDate } from "@transformers/date";
import { GSGrid, Pagination } from "@components";

type Props = $Exact<{
  changelog: Array<HierarchyChangelog>,
  pagination: PaginationExtendedType,
  onNextPage: (page: number) => void,
  ...PropsFromLocalize,
}>;

export class ChangelogList extends React.Component<Props> {
  get columns() {
    return [
      {
        name: this.props.t("CHANGE_ID"),
        key: "id",
        width: 120,
        align: "center",
      },
      {
        name: this.props.t("CHANGE_DATE"),
        key: "changeDate",
        width: 120,
        renderCell: ({ row }: Object) => formatDate(row.createdAt),
      },
      {
        name: this.props.t("CHANGED_BY"),
        key: "changedBy",
        width: 200,
        align: "left",
        renderCell: ({ row }: Object) => (
          <div
            title={`${row.createdBy.firstName} ${row.createdBy.lastName}`}
            className="text-ellipsis"
          >{`${row.createdBy.firstName} ${row.createdBy.lastName}`}</div>
        ),
      },
      {
        name: this.props.t("CHANGE_TYPE"),
        key: "changedType",
        width: 200,
        align: "left",
        renderCell: ({ row }: Object) => (
          <div title={this.props.t(row.operation)} className="text-ellipsis">
            {this.props.t(row.operation)}
          </div>
        ),
      },
      {
        name: this.props.t("CHANGE_DESCRIPTION"),
        key: "description",
        align: "left",
        renderCell: ({ row }: Object) => (
          <div title={this.props.t(row.description)} className="text-ellipsis">
            {row.description}
          </div>
        ),
      },
    ];
  }

  render() {
    return (
      <React.Fragment>
        <GSGrid columns={this.columns} rows={this.props.changelog} />
        <div className="w-100">
          <Pagination
            className="mx-auto mt-3 d-block"
            currentPage={this.props.pagination.pageNumber}
            totalPages={this.props.pagination.totalPages}
            onChange={this.props.onNextPage}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default localize()(ChangelogList);
